import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from "@angular/router";
import { Observable, map } from "rxjs";
import { FirstLoginService } from "../shared/services/first-login.service";

@Injectable({
    providedIn: "root",
})
export class NotFirstLoginGuard implements CanActivate {
    constructor(private firstLoginService: FirstLoginService, private router: Router) {}

    canActivate(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
        return this.firstLoginService.isSiteSet().pipe(
            map((isSiteSet) => {
                if (isSiteSet) {
                    return true;
                }
                this.router.navigate(["/firstLogin"]);
                return false;
            })
        );
    }
}
